import 'styles/tailwind.css';
import 'styles/global.css';
import '@eduzz/ui-antd-theme/style.css';
import 'styles/antd-fixes.css';
import 'react-toastify/dist/ReactToastify.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'config/dayjs';
import 'config/yupLocale';
import 'config/chat';
import 'v2/services/eduzzAccount';
import './hotjar';

import * as React from 'react';

import { createRoot } from 'react-dom/client';

import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { IS_PROD } from './settings';

const root = createRoot(document.getElementById('app') as HTMLElement);
root.render(<App />);

if (!IS_PROD) {
  reportWebVitals();
}
